// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"4a3ebd1a","159":"0ef651cd","253":"8ba8654c","279":"86788d85","464":"ce62e991","505":"29237cf3","620":"3a610015","688":"412816c4"}[chunkId] + ".chunk.js";
};